import React from 'react';

import {SINGLE_DATASET_INPUT_STEP_DATA_NAME} from 'analysis-tool/AnalysisStepDataNames';
import {findAndAssertSingleStepDataFrameId} from 'analysis-tool/data/findAndAssertStepDataFrameIds';
import {getTableLineageAncestorSteps} from 'pipelines/StepLineageUtils';

import RegressionStepEditor from '../charting/RegressionStepEditor';
import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function EditRegressionView({
  clientStateId,
  analysis,
  onCloseStepInitializationView,
  step: regressionStep,
}: MainViewComponentProps<AnalysisMainViewItemType.EDIT_REGRESSION>): JSX.Element {
  const inputDataFrameId = findAndAssertSingleStepDataFrameId(
    regressionStep,
    SINGLE_DATASET_INPUT_STEP_DATA_NAME,
    true
  );
  const viewSteps = getTableLineageAncestorSteps(analysis, regressionStep);

  function onCloseRegression(): void {
    onCloseStepInitializationView({type: AnalysisMainViewItemType.REGRESSION, stepId: regressionStep.id});
  }

  return (
    <RegressionStepEditor
      analysis={analysis}
      viewSteps={viewSteps}
      clientStateId={clientStateId}
      inputDataFrameId={inputDataFrameId}
      onCloseRegression={onCloseRegression}
    />
  );
}
